import { IDatabasePresenter } from '@makyoapp/makyo-sdk/models/Database'
import {
  DbItemAdapter,
  DbSource,
  fromSdkAppBriefList,
  fromSdkOrgBrief,
  fromSdkTeamBriefList,
} from '@makyoapp/makyo-common'

import { getLanguage, Language } from '@/lib/language-flag'

export interface DbItemAdapterV2 extends DbItemAdapter {
  defaultLanguage: string
}

export function fromSdkDbSources(sdkSources: string): DbSource[] {
  const sources: DbSource[] = []
  const entries = Object.values(DbSource)
  for (const v in entries) {
    if (v.toLowerCase() === sdkSources.toLowerCase()) {
      sources.push(v as DbSource)
    } else {
      console.error('not sure! undefined value')
    }
  }

  return sources
}

export function fromSdkDbList(dbs: IDatabasePresenter[]) {
  return dbs.map((db) => fromSdkDb(db))
}

export function fromSdkDb(db: IDatabasePresenter): DbItemAdapterV2 {
  return {
    apps: Array.isArray(db._Projects) ? fromSdkAppBriefList(db._Projects) : [],
    connectionCount: 0,
    id: db._id,
    name: db._Name,
    org: fromSdkOrgBrief(db._Organization),
    recordCount: db._Records,
    size: db._Size,
    //sources: fromSdkDbSource(db._Source),
    source: db._Source as DbSource,
    tableCount: db._Tables,
    isExternalDb: db._IsExternalDB,
    externalDb: {
      pluginRefId: db._ExternalDB._OrgPluginID,
      lastSyncAt: new Date(db._ExternalDB._LastSyncAt),
      isSyncing: db._ExternalDB._Syncing,
      isSynced: db._ExternalDB._Synced,
    },
    teams: Array.isArray(db._Teams)
      ? fromSdkTeamBriefList(db._Teams.filter((dbt) => dbt._id !== '' && dbt._id !== undefined && dbt._id !== null))
      : [],
    created: new Date(db._CreatedAt),
    updated: new Date(db._UpdatedAt),
    languages: db._Languages,
    defaultLanguage: db._DefaultLanguage,
  }
}

function filterMapLanguages(languages: string[], defaultLang = true): Language[] {
  // Map the provided languages, filtering out any invalid ones
  const mappedLanguages: Language[] = languages
    .map((lng) => getLanguage(lng))
    .filter((lang): lang is Language => lang !== undefined)

  // Optionally prepend 'en' (English) if not already present
  if (defaultLang && !languages.includes('en')) {
    return [getLanguage('en')!, ...mappedLanguages]
  }

  return mappedLanguages
}
